import { render, staticRenderFns } from "./AddedDivisions.vue?vue&type=template&id=7fbdc957&"
import script from "./AddedDivisions.vue?vue&type=script&lang=js&"
export * from "./AddedDivisions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports